export default __webpack_public_path__ + "static/media/G0540.CFS_v2.0_EN_Card-2Up.1686221880000.bb265699.jpg";